// Flight line that puts each flight on a separate line and does not wrap.

import React from 'react';
import style from './flightPlanTrack.module.scss';
import classNames from 'classnames';
import {
    AirportNode,
    EmptyDurationNode,
    ExpandedDurationNode,
    Node
} from 'acscp/components/legs/flightPlan/flightPlanNodes';
import { Leg } from 'acscp/store';

export interface SplitLineFlightPlanTrackProps {
    legs: Leg[];
}

export class SplitLineFlightPlanTrack extends React.Component<SplitLineFlightPlanTrackProps> {
    render(): JSX.Element {
        const { legs } = this.props;
        const clusteredNodes = this.parseLegsIntoClusteredNodes(legs);

        return(
            <div>
                {clusteredNodes.map((cluster: Node[], index: number) => this.renderCluster(cluster, index))}
            </div>
        );
    }

    // We don't need to do anything here since the individual rows should never overflow.
    register = (): void => {};

    parseLegsIntoClusteredNodes(legs: Leg[]): Node[][] {
        const clusters: Node[][] = [];

        for (const leg of legs) {
            const nodes = new Array<Node>();

            nodes.push(new EmptyDurationNode(this.register));

            const departure = new AirportNode(leg.departureLocation, leg.departureAirportId);
            nodes.push(departure);

            nodes.push(new ExpandedDurationNode(leg.flightTimeDuration, this.register));

            const arrival = new AirportNode(leg.arrivalLocation, leg.arrivalAirportId);
            nodes.push(arrival.markAsHop());

            nodes.push(new EmptyDurationNode(this.register));

            clusters.push(nodes);
        }
        return clusters;
    }

    renderCluster(cluster: Node[], clusterKey: number): JSX.Element {
        return (
            <div key={clusterKey} className={classNames(style.Cluster, style.FullWidthCluster)}>
                {cluster.map((node: Node, index: number) => node.render(index))}
            </div>
        );
    }
}
